import template from './swag-cms-extensions-section-scroll-behavior-config.html.twig';
import './swag-cms-extensions-section-scroll-behavior-config.scss';

const { mapPropertyErrors } = Shopware.Component.getComponentHelper();

export default {
    template,

    inject: [
        'repositoryFactory',
        'acl',
    ],

    props: {
        section: {
            type: Object,
            required: true,
        },
    },

    computed: {
        scrollNavigationRepository() {
            return this.repositoryFactory.create('swag_cms_extensions_scroll_navigation');
        },

        scrollNavigationExtensionDefined() {
            return this.section.extensions.swagCmsExtensionsScrollNavigation !== undefined;
        },

        swagCmsExtensionsScrollNavigation() {
            return this.section.extensions.swagCmsExtensionsScrollNavigation;
        },

        ...mapPropertyErrors('swagCmsExtensionsScrollNavigation', [
            'displayName',
        ]),
    },

    watch: {
        section: {
            handler() {
                if (typeof this.section.extensions?.swagCmsExtensionsScrollNavigation === 'object') {
                    return
                }
                this.createDefaultScrollNavigation();
            },
            immediate: true,
        },
    },

    methods: {
        createDefaultScrollNavigation() {
            if (typeof this.section.extensions?.swagCmsExtensionsScrollNavigation === 'object') {
                return
            }

            const defaultExtension = this.scrollNavigationRepository.create(Shopware.Context.api);
            this.section.extensions.swagCmsExtensionsScrollNavigation = defaultExtension;
        },
    },
};
